export default __webpack_public_path__ + "static/media/08.1374c76c.jpg";